export default (apiMethods, endpoints) => ({

    getTags: () => {
        return apiMethods.get(endpoints.GET_TAGS_ENDPOINT);
    }

})



// WEBPACK FOOTER //
// ./src/lib/api-tag.js